/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SpinOutcomeEffect } from './SpinOutcomeEffect';
import {
    SpinOutcomeEffectFromJSON,
    SpinOutcomeEffectFromJSONTyped,
    SpinOutcomeEffectToJSON,
    SpinOutcomeEffectToJSONTyped,
} from './SpinOutcomeEffect';

/**
 * 
 * @export
 * @interface WheelSpinResultResponse
 */
export interface WheelSpinResultResponse {
    /**
     * Index of the winning outcome
     * @type {number}
     * @memberof WheelSpinResultResponse
     */
    outcomeIndex: number;
    /**
     * Label of the winning segment
     * @type {string}
     * @memberof WheelSpinResultResponse
     */
    outcomeLabel: string;
    /**
     * Color of the winning segment
     * @type {string}
     * @memberof WheelSpinResultResponse
     */
    outcomeColor: string;
    /**
     * CSS rotation degrees for animation
     * @type {number}
     * @memberof WheelSpinResultResponse
     */
    rotationDegrees: number;
    /**
     * Spins remaining in the current window
     * @type {number}
     * @memberof WheelSpinResultResponse
     */
    spinsRemaining: number;
    /**
     * Total spins taken on this model
     * @type {number}
     * @memberof WheelSpinResultResponse
     */
    totalSpins: number;
    /**
     * Whether a reward was successfully distributed
     * @type {boolean}
     * @memberof WheelSpinResultResponse
     */
    rewardsGranted: boolean;
    /**
     * Reward response objects — opaque, shape varies per reward type.
     * Frontend does not consume this field directly (reward UI is
     * driven by GlobalRewardNotifications via DistributedReward), so
     * the openapi-generator's inline emission is acceptable here. A
     * named schema would need at least one concrete property to
     * generate as a model class — `additionalProperties: true` alone
     * does not produce a usable type, and inventing a fake field to
     * satisfy the generator would leak into the wire contract.
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof WheelSpinResultResponse
     */
    rewards: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {SpinOutcomeEffect}
     * @memberof WheelSpinResultResponse
     */
    effect?: SpinOutcomeEffect;
    /**
     * POINT_MULTIPLIER only — epoch ms at which the doubled window closes.
     * @type {number}
     * @memberof WheelSpinResultResponse
     */
    multiplierExpiresAt?: number;
    /**
     * POINT_PENALTY only — how many points were taken off.
     * @type {number}
     * @memberof WheelSpinResultResponse
     */
    pointsRemoved?: number;
}



/**
 * Check if a given object implements the WheelSpinResultResponse interface.
 */
export function instanceOfWheelSpinResultResponse(value: object): value is WheelSpinResultResponse {
    if (!('outcomeIndex' in value) || value['outcomeIndex'] === undefined) return false;
    if (!('outcomeLabel' in value) || value['outcomeLabel'] === undefined) return false;
    if (!('outcomeColor' in value) || value['outcomeColor'] === undefined) return false;
    if (!('rotationDegrees' in value) || value['rotationDegrees'] === undefined) return false;
    if (!('spinsRemaining' in value) || value['spinsRemaining'] === undefined) return false;
    if (!('totalSpins' in value) || value['totalSpins'] === undefined) return false;
    if (!('rewardsGranted' in value) || value['rewardsGranted'] === undefined) return false;
    if (!('rewards' in value) || value['rewards'] === undefined) return false;
    return true;
}

export function WheelSpinResultResponseFromJSON(json: any): WheelSpinResultResponse {
    return WheelSpinResultResponseFromJSONTyped(json, false);
}

export function WheelSpinResultResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WheelSpinResultResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'outcomeIndex': json['outcomeIndex'],
        'outcomeLabel': json['outcomeLabel'],
        'outcomeColor': json['outcomeColor'],
        'rotationDegrees': json['rotationDegrees'],
        'spinsRemaining': json['spinsRemaining'],
        'totalSpins': json['totalSpins'],
        'rewardsGranted': json['rewardsGranted'],
        'rewards': json['rewards'],
        'effect': json['effect'] == null ? undefined : SpinOutcomeEffectFromJSON(json['effect']),
        'multiplierExpiresAt': json['multiplierExpiresAt'] == null ? undefined : json['multiplierExpiresAt'],
        'pointsRemoved': json['pointsRemoved'] == null ? undefined : json['pointsRemoved'],
    };
}

export function WheelSpinResultResponseToJSON(json: any): WheelSpinResultResponse {
    return WheelSpinResultResponseToJSONTyped(json, false);
}

export function WheelSpinResultResponseToJSONTyped(value?: WheelSpinResultResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'outcomeIndex': value['outcomeIndex'],
        'outcomeLabel': value['outcomeLabel'],
        'outcomeColor': value['outcomeColor'],
        'rotationDegrees': value['rotationDegrees'],
        'spinsRemaining': value['spinsRemaining'],
        'totalSpins': value['totalSpins'],
        'rewardsGranted': value['rewardsGranted'],
        'rewards': value['rewards'],
        'effect': SpinOutcomeEffectToJSON(value['effect']),
        'multiplierExpiresAt': value['multiplierExpiresAt'],
        'pointsRemoved': value['pointsRemoved'],
    };
}

